import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

import { ShellComponent } from './shell/shell.component';
import { StockLocationPromptComponent } from './components/stock-location-prompt.component';
import { SharedModule } from './shared.module';
import { ApiInterceptor } from './interceptors/api.interceptor';
import { AuthGuard } from './guards/auth.guard';
import { AuthService } from './services/auth.service';
import { ApiService } from './services/api.service';

@NgModule({
    declarations: [ShellComponent, StockLocationPromptComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        RippleModule,
        TranslateModule,
        SharedModule,
    ],
    providers: [
        AuthService,
        ApiService,
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        }
    ],
    exports: [ShellComponent, SharedModule, CommonModule, RouterModule, TranslateModule]
})
export class CoreModule { }

